
import { Component, Vue, Mixins } from 'vue-property-decorator'
import Visualization from './Visualization.vue'
import GridMaker from 'd3-v4-grid'

@Component
export default class Grid extends Mixins(Visualization) {
  /**
   * Make a grid.
   */
  public makeGrid(
    values: any[],
    width: number,
    height: number,
    parentGrid?: any,
    padding: number = 0.05
  ) {
    const grid = GridMaker()
      .data(values)
      .bands(true)
      .padding([padding, padding])
      .size([width, height])
      .layout()

    const nodes = grid.nodes()
    const [gridWidth, gridHeight] = grid.nodeSize()

    nodes.forEach((node, index) => {
      node.width = gridWidth * (1 - padding * 2)
      node.height = gridHeight * (1 - padding * 2)

      node.wPadding = gridWidth * padding
      node.hPadding = gridHeight * padding

      node.x1 = node.x + (parentGrid ? parentGrid.x1 || 0 : 0) + node.wPadding
      node.x2 = node.x1 + node.width
      node.x = node.x1 + node.width / 2

      node.y1 = node.y + (parentGrid ? parentGrid.y1 || 0 : 0) + node.hPadding
      node.y2 = node.y1 + node.height
      node.y = node.y1 + node.height / 2

      node.index = index
    })

    return nodes
  }

  /**
   * Datasets grid.
   */
  get datasetsGrid() {
    return this.makeGrid(
      this.__data.datasets,
      this.width,
      this.height,
      null,
      0.05
    )
  }

  /**
   * Data grid.
   */
  get dataGrids() {
    return this.datasetsGrid.map(grid => {
      const unique = [...new Set(grid.data)].map(label => ({ label }))
      return this.makeGrid(unique, grid.width, grid.height, grid, 0.06)
    })
  }
}
